import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import {
  ApiModule,
  Configuration,
  ConfigurationParameters,
} from 'workflow-definition/openapi';

import {
  provideAngularQuery,
  QueryClient,
} from '@tanstack/angular-query-experimental';

import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { RemoveTrailingSlashInterceptor } from './interceptors/remove-trailing-slash.interceptor';

const configurationFactory = () => {
  const configParams: ConfigurationParameters = {
    basePath: environment.apiBaseUrl,
    encodeParam(param) {
      return param.value ? String(param.value) : '';
    },
  };
  return new Configuration(configParams);
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom([
      BrowserAnimationsModule,
      ApiModule.forRoot(configurationFactory),
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ]),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        AuthInterceptor,
        RemoveTrailingSlashInterceptor,
        ErrorInterceptor,
      ])
    ),
    provideAngularQuery(new QueryClient()),
    MessageService,
  ],
};
